// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__rwB1y","spin":"styles_spin__DN_rI"};